/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-10-20 22:10:33
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-09-15 14:49:54
 * @FilePath: /wemeet-web-activity/src/pages/event/[eventid]/registration/buyer/components/schedules/hooks.tsx
 * @Description: 展示日程详情
 */
import React from 'react';
import { Modal } from '@tencent/tea-component';
import { Toast } from '@tencent/calendar-web-component-mobile';
import { getBetweenDate } from '@utils/parse-date';
import dataReport from '@utils/data-report';
import { SchedulerDataList } from '@quickService/PublicRegistrationQueryEventSchedulers';
import Image from '@component/Image';
import './index.scss';
// 展示日程详情
const showScheduleDetail = (
  { pics_source_list, name, description, guests, plans, scheduler_id }: SchedulerDataList[0],
  defaultImg: string,
  eventId: string,
) => {
  const hasImg = pics_source_list && pics_source_list.length > 0;
  const hasDescription = !!description;
  const hasGuest = guests && guests?.length > 0;
  const hasPlan = plans && plans?.length > 0;

  // 展示日程卡片上报
  dataReport('e#event_registrationpage#event_schedule#click', {
    is_null: Number(hasDescription),
    schedule_ID: scheduler_id,
    activity_id: eventId,
  });

  // 日程详情曝光
  dataReport('e#event_registrationpage#schedule_detail#exposure', {
    schedule_ID: scheduler_id,
    activity_id: eventId,
  });

  if (!(hasImg || hasDescription || hasGuest || hasPlan)) {
    Toast.info('没有更多日程信息');
    return;
  }

  const scheduleModal = Modal.show({
    // 支持点击遮罩关闭
    maskClosable: true,
    className: 'registration-schedule-modal',
    children: (
      <>
        <div className="img">
          <Image src={pics_source_list?.[0]?.url || defaultImg} />
        </div>
        <div className="registration-schedule-modal-bd">
          <div className="hd">{name}</div>
          {hasDescription && <div className="desc">{description}</div>}
          {hasGuest && (
            <div className="bd-panel">
              <div className="bd-panel-hd">嘉宾</div>
              {guests?.map((item) => (
                <div className="bd-panel-guest">
                  <div className="bd-panel-guest-img">
                    <Image src={item.url} width={150} />
                  </div>
                  <div className="bd-panel-guest-dtl">
                    <div className="bd-panel-guest-dtl-name">{item.name}</div>
                    {item.company}
                  </div>
                </div>
              ))}
            </div>
          )}
          {hasPlan && (
            <div className="bd-panel">
              <div className="bd-panel-hd">议程</div>
              {plans?.map((item) => (
                <div className="bd-panel-plan">
                  <div className="bd-panel-plan-hd">
                    {getBetweenDate(item.begin_time, item.end_time)}
                  </div>
                  <div className="bd-panel-plan-hd">{item.title}</div>
                  <div className="desc">{item.description}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </>
    ),
    onClose: () => scheduleModal.destroy(),
  });
};

export default showScheduleDetail;
